const speedometerColors = [
  '#00a4ff',
  '#ffe13e',
  '#fab723',
  '#fd6383',
  '#bb0611'
];

export default speedometerColors;
